












import { defineComponent, computed, ComputedRef, ref, Ref, onMounted } from '@vue/composition-api';

import ChannelListData from '@/ts/Channels/ChannelListData';
import { Actions } from '@/ts/store/modules/Channels/constants';

import ChannelListItem from './components/ChannelListItem.vue';

export default defineComponent({
  components: {
    ChannelListItem,
  },
  props: {
    initialChannelId: Number,
    projectId: Number,
  },
  setup({ initialChannelId, projectId }, { emit, root }) {

    const store = root.$store;
    // @ts-ignore
    const router = root.$router;

    const showCreateChannelModal: Ref<boolean> = ref(false); 

    const selectedChannelId: Ref<any> = ref(); 

    const channelList: ComputedRef<ChannelListData[]> = computed(() => {
       return store.getters['Channels/getProjectChannelList'];
    });

    const onChannelSelect = (channel: ChannelListData) => {
      selectedChannelId.value = channel.id;
      emit('onChannelSelected', channel);
    };

    onMounted(() => {
      selectedChannelId.value = initialChannelId;
    });

    return {
      channelList,
      showCreateChannelModal,
      onChannelSelect,
      selectedChannelId,
    };
  },
});
